import React, { useState, useEffect } from "react";
import "./whatsapp.css";
import whatsappIcon from "../../Assets/whatsapp.svg";

const WhatsApp = () => {
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState(false);

  /* Fade in after 2s so it doesn't distract on first load */
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 2000);
    return () => clearTimeout(t);
  }, []);

  return (
    <a
      href="https://wa.me/917383677715"
      target="_blank"
      rel="noopener noreferrer"
      className={`wa-float ${visible ? 'wa-float--visible' : ''}`}
      aria-label="Chat with us on WhatsApp"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Pulse rings */}
      <span className="wa-pulse wa-pulse-1" />
      <span className="wa-pulse wa-pulse-2" />

      {/* Icon button */}
      <span className="wa-btn">
        <img src={whatsappIcon} alt="WhatsApp" className="wa-icon" />
      </span>

      {/* Tooltip */}
      <span className={`wa-tooltip ${hovered ? 'wa-tooltip--visible' : ''}`}>
        Chat with us!
      </span>
    </a>
  );
};

export default WhatsApp;